// @ts-nocheck
import { Fragment, h } from "preact";
import { MenuOutlined } from "@ant-design/icons";
import { ContentHeader, StyledButton, StyledDrawer } from "./styled";
import { TextLogo } from "../header/styled";
import Sidebar from "../side-bar";

interface INavbarHamburger {
  collapsed: boolean;
  onCollapse: any;
}

const NavbarHamburger = ({ collapsed, onCollapse }: INavbarHamburger) => {
  return (
    <>
      <StyledButton
        className="menu"
        icon={<MenuOutlined />}
        onClick={() => onCollapse(!collapsed)}
      />
      <StyledDrawer
        visible={collapsed}
        placement="left"
        onClose={() => onCollapse(false)}
        closable={false}
      >
        <ContentHeader>
          <TextLogo isMobile={true}>HYDROPLUS ECOSYSTEM</TextLogo>
        </ContentHeader>
        <Sidebar onCollapse={(c) => onCollapse(c)} />
      </StyledDrawer>
    </>
  );
};

export default NavbarHamburger;
